import { Divider, Stack } from '@mui/material';
import {
  mapCountry,
  mapCurrency,
  mapIndustry,
  mapProjectSize,
  mapService,
} from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import { mapTechLanguage, mapTechPlatform, mapTechTool } from '../../../../utils/enums';
import CustomInput from '../../../../components/custom-input/CustomInput';

const DetailsStep = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing={5} width="100%">
      <Stack spacing={3} direction="column" width="50%" gap={1}>
        <CustomInput
          input={<CustomInput.Autocomplete />}
          name="details.services"
          label={t('settings.companyProfile.services')}
          required
          multiple
          withChips
          choices={mapService}
          translation={{ ns: 'enum' }}
          placeholder={t('caseStudies.selectProvidedServices')}
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          multiple
          withChips
          name="details.tools"
          label={t('settings.companyProfile.techTools')}
          choices={mapTechTool}
          placeholder={t('caseStudies.selectUsedTools')}
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          multiple
          withChips
          name="details.platforms"
          label={t('settings.companyProfile.techPlatforms')}
          choices={mapTechPlatform}
          placeholder={t('caseStudies.selectUsedPlatforms')}
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          name="details.languages"
          multiple
          withChips
          label={t('settings.companyProfile.programmingLanguages')}
          choices={mapTechLanguage}
          placeholder={t('caseStudies.selectUsedLanguages')}
        />
      </Stack>

      <Divider orientation="vertical" flexItem />

      <Stack spacing={3} direction="column" width="50%" gap={1}>
        <Stack direction="row">
          <Stack
            sx={{
              width: 'min-width',
            }}
          >
            <CustomInput
              input={<CustomInput.Select />}
              name="details.currency"
              choices={mapCurrency}
              label={t('caseStudies.projectSize')}
              required
            />
          </Stack>
          <Stack
            sx={{
              flex: 1,
            }}
          >
            <CustomInput
              input={<CustomInput.Select />}
              name="details.projectSize"
              required
              // This label is passed so that it applies the margin as if label was there and now it aligns with currency field
              label="&zwnj;"
              choices={mapProjectSize}
              placeholder={t('caseStudies.selectProjectSize')}
            />
          </Stack>
        </Stack>

        <CustomInput
          input={<CustomInput.Autocomplete />}
          multiple
          withChips
          name="details.geographyFocus"
          label={t('settings.companyProfile.targetMarkets')}
          required
          choices={mapCountry}
          translation={{ t, ns: 'enum' }}
          placeholder={t('caseStudies.selectTargetMarket')}
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          name="details.industries"
          label={t('caseStudies.clientIndustry')}
          multiple
          required
          withChips
          choices={mapIndustry}
          translation={{ ns: 'enum' }}
          placeholder={t('caseStudies.selectClientIndustry')}
        />
      </Stack>
    </Stack>
  );
};

export default DetailsStep;
